import { Button } from '@vinted/web-ui'
import { omit } from 'lodash'

type ConversationActionPrimaryDto = {
  primary?: boolean
}

type Props = ConversationActionPrimaryDto & Partial<React.ComponentProps<typeof Button>>

const ConversationActionButton = (props: Props) => {
  const getActionButtonStyle = props.primary ? 'filled' : undefined

  const buttonProps: React.ComponentProps<typeof Button> = omit(props, 'primary')

  return <Button {...buttonProps} size={props.size || 'small'} styling={getActionButtonStyle} />
}

export default ConversationActionButton
